import { primaryRegularFont, theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const container = css`
  display: flex;
  align-items: center;
`;

export const copy = css`
  ${theme.responsiveText.BODY.MD}
`;

export const heading = css`
  ${primaryRegularFont};
  margin: 0;
`;

export const button = css`
  background: none;
  border: none;
  color: var(--brand-purple-base-high-contrast);
  text-decoration: underline;
  ${primaryRegularFont};
  padding: 0;
  margin-left: auto;
  cursor: pointer;
`;

export const flag = css`
  display: block;
  margin: 0 ${spacing.xs}px;
`;
